module.exports = __webpack_public_path__ + "static/media/design8.5fdcfd16.jpg";